import {FOOTER_MENU} from '@client/constants/footerMenu';

export default class FooterSettings {
  constructor() {
    this.menu = FOOTER_MENU;
  }
}
